import KunLoading66 from './src/index'

KunLoading66.install = function (Vue) {
	Vue.component(KunLoading66.name, KunLoading66);
}

export default KunLoading66;
